var borders_default = {
  "borderT": "ghwem",
  "borderB": "_0u87u",
  "borderL": "FD9PT",
  "borderR": "VLFrT"
};
export {
  borders_default as default
};
//# sourceMappingURL=borders-scss.js.map
